import React from "react";
import "../Styles/Frontpage.css";

import templeImage from "../Assests/bhad2-removebg-preview.png";

function Frontpage() {
  return (
    <div className="frontpage">

      {/* Left Side - History */}
      <div className="history-section">

              <h2>Puliyampilly Nambooriyachan</h2>

        <p>
          The history of this deity is inseparable from Puliyampilly
          Nambooriyachan (or Puliyampilly Namboori), a legendary sage,
          scholar, Saktheya Upasakan and Tantric practitioner whose life and miracles are
          famously chronicled in Kottarathil Sankunni's Aithihyamala
          (The Garland of Legends), a classic compendium of Kerala folklore.
        </p>
        
            <p>
          This Temple is an ancient and revered shrine
      located in North Paravoor, Ernakulam District, Kerala. The temple stands uniquely
       at the center of a four-way road junction, where vehicles pass around it from all 
       directions throughout the day. Beneath the shelter of a majestic banyan tree, the 
       sacred shrine is enclosed by a simple four-foot-high circular cement structure.
        Despite its modest appearance and its location amidst the busy traffic, the temple
         radiates an extraordinary divine presence (Chaithanyam). It is beleived that the spirit of Puliyampilli Namboothiri resides in this banyan tree .For generations, 
         devotees have visited this sacred place with unwavering faith, believing that
          Goddess Bhadrakali listens to their prayers and showers them with protection,
           strength, and blessings.
            </p>

        <h3>The Intense Upasana (Devotion)</h3>

        <p>
          Puliyampilly Namboothiri was an ardent devotee of Goddess
          Bhadrakali . He practiced severe penance
          (Tapacharya) to invoke the fierce aspect of Adi Shakti —
          Goddess Bhadrakali.There is no evil spirit that will not leave if Puliyampilly exorcises it ,so great and severe was his worship of Goddess Bhadrakali.
        </p>
        

        <h3>The Miracle of the Two Moons</h3>

        <p>
          The most famous folklore attached to his name describes a time
          when he challenged the skepticism of a local king. On a
          pitch-black Karkidaka Amavasi (new moon night), through his
          absolute spiritual mastery and the grace of Bhadrakali, he made
          two glowing full moons appear simultaneously in the midnight sky,
          leaving the king and the public in absolute awe.
        </p>

              </div>


      {/* Right Side - Goddess Image */}
      <div className="image-section">

        <img
          src={templeImage}
          alt="Goddess Bhadrakali"
          className="front-image"
        />

      </div>

    </div>
  );
}

export default Frontpage;